import { routerPath, webColor, skills } from "../../assets/data";

const initialState = {
  routerPath: routerPath,
  webColor: webColor,
  activeColor: "#00BFA6",
  skills: skills,
//   imageDocs: [],
};

export const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ROUTER_PATH_UPDATE":
      return {
        ...state,
        routerPath: action.routerPath,
      };
    case "WEB_COLOR_CHANGE":
      return {
        ...state,
        webColor: action.webColor,
        activeColor: action.activeColor,
      };
    case "IMAGE_FETCH":
      return {
        ...state,
        imageDocs: action.imageDocs,
      };
    default:
      return state;
  }
};
